import progressionConfig from "../../../shared/journey_progression.json";

export const DEFAULT_VIGNETTE_ID = "stag-beetle";

export const VIGNETTE_ASSETS = {
  STAG_BEETLE: "/game/avatars/8e4548b3-f3aa-48ac-8954-917f8ee431b7-removebg-preview.png",
  SNAIL: "/game/avatars/7e7341b3-19b4-42c7-bb9c-80b9d3bfdfb7-removebg-preview.png",
  SOIL_GUARDIAN: "/game/avatars/caaef1a6-4ab6-41ed-ba11-713ba49deeba-removebg-preview.png",
  ACORN: "/game/avatars/bellota2-removebg-preview.png",
  DIGGER: "/game/avatars/digger-removebg-preview.png",
  FLEA: "/game/avatars/flee-removebg-preview.png",
  GEODE: "/game/avatars/geode-removebg-preview.png",
  GHOST: "/game/avatars/ghost-removebg-preview.png",
  GREEN_ROCK: "/game/avatars/greenrock-removebg-preview.png",
  MUSHROOM: "/game/avatars/mushroom-removebg-preview.png",
  PINE: "/game/avatars/pine-removebg-preview.png",
  WORM: "/game/avatars/worm-removebg-preview.png",
  ANT: "/game/avatars/ant-removebg-preview.png",
  INSECT: "/game/avatars/insect1-removebg-preview.png",
  GRASSHOPPER: "/game/avatars/saltamontes-removebg-preview.png",
  PLANT_MAN: "/game/avatars/plantman-removebg-preview.png",
  ROCK: "/game/avatars/rock2-removebg-preview.png",
  TREE: "/game/avatars/tree-removebg-preview.png",
  GEODE_MAN: "/game/avatars/geodeman-removebg-preview.png",
  DANDELION: "/game/avatars/liontooth-removebg-preview.png",
  WOOD_GUARDIAN: "/game/avatars/maderaman-removebg-preview.png",
  TREE_2: "/game/avatars/tree2-removebg-preview.png",
};

const AVATAR_UNLOCKS = Object.fromEntries(
  (progressionConfig.avatarUnlocks || []).map((unlock) => [unlock.id, unlock])
);

const avatar = (id, labelKey, imagePath) => ({
  id,
  labelKey,
  imagePath,
  unlock: AVATAR_UNLOCKS[id] || { id, type: "journey_complete" },
});

export const VIGNETTE_CATALOG = [
  avatar("stag-beetle", "vignettes.stagBeetle", VIGNETTE_ASSETS.STAG_BEETLE),
  avatar("acorn", "vignettes.acorn", VIGNETTE_ASSETS.ACORN),
  avatar("digger", "vignettes.digger", VIGNETTE_ASSETS.DIGGER),
  avatar("flea", "vignettes.flea", VIGNETTE_ASSETS.FLEA),
  avatar("geode", "vignettes.geode", VIGNETTE_ASSETS.GEODE),
  avatar("ghost", "vignettes.ghost", VIGNETTE_ASSETS.GHOST),
  avatar("green-rock", "vignettes.greenRock", VIGNETTE_ASSETS.GREEN_ROCK),
  avatar("mushroom", "vignettes.mushroom", VIGNETTE_ASSETS.MUSHROOM),
  avatar("pine", "vignettes.pine", VIGNETTE_ASSETS.PINE),
  avatar("worm", "vignettes.worm", VIGNETTE_ASSETS.WORM),
  avatar("snail", "vignettes.snail", VIGNETTE_ASSETS.SNAIL),
  avatar("soil-guardian", "vignettes.soilGuardian", VIGNETTE_ASSETS.SOIL_GUARDIAN),
  avatar("ant", "vignettes.ant", VIGNETTE_ASSETS.ANT),
  avatar("insect", "vignettes.insect", VIGNETTE_ASSETS.INSECT),
  avatar("grasshopper", "vignettes.grasshopper", VIGNETTE_ASSETS.GRASSHOPPER),
  avatar("plant-man", "vignettes.plantMan", VIGNETTE_ASSETS.PLANT_MAN),
  avatar("rock", "vignettes.rock", VIGNETTE_ASSETS.ROCK),
  avatar("tree", "vignettes.tree", VIGNETTE_ASSETS.TREE),
  avatar("geode-man", "vignettes.geodeMan", VIGNETTE_ASSETS.GEODE_MAN),
  avatar("dandelion", "vignettes.dandelion", VIGNETTE_ASSETS.DANDELION),
  avatar("wood-guardian", "vignettes.woodGuardian", VIGNETTE_ASSETS.WOOD_GUARDIAN),
  avatar("tree-2", "vignettes.treeTwo", VIGNETTE_ASSETS.TREE_2),
];

export function getFallbackVignette() {
  return VIGNETTE_CATALOG[0];
}

export function findVignette(vignetteId) {
  return VIGNETTE_CATALOG.find((item) => item.id === vignetteId) || getFallbackVignette();
}
